import { render, staticRenderFns } from "./AddClientContainer.vue?vue&type=template&id=1f527ca6&scoped=true&"
import script from "./AddClientContainer.vue?vue&type=script&lang=js&"
export * from "./AddClientContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f527ca6",
  null
  
)

export default component.exports